import { motion } from "framer-motion";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const EMAIL = "corewebbdesign@gmail.com";
const PHONE = "826-202-6224";

const Row = ({ href, icon: Icon, label, value, testId, i }) => (
  <Reveal delay={i * 0.12}>
    <motion.a
      href={href}
      data-testid={testId}
      whileHover="hover"
      className="group flex items-center justify-between gap-6 border-b border-white/10 py-8 sm:py-10"
    >
      <div className="min-w-0">
        <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">
          <Icon className="h-4 w-4 text-sky-300" /> {label}
        </span>
        <span className="mt-3 block break-all font-display text-2xl font-medium tracking-tight text-white transition-colors duration-500 group-hover:text-sky-300 sm:text-5xl lg:text-6xl">
          {value}
        </span>
      </div>
      <motion.span
        variants={{ hover: { rotate: 45, scale: 1.1 } }}
        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/20 text-white sm:h-16 sm:w-16"
      >
        <ArrowUpRight className="h-5 w-5" />
      </motion.span>
    </motion.a>
  </Reveal>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative overflow-hidden bg-[#0A1128] py-28 sm:py-40">
    <div className="pointer-events-none absolute bottom-0 left-1/2 h-[500px] w-[900px] -translate-x-1/2 rounded-full bg-blue-700/20 blur-[140px]" />
    <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
      <Reveal>
        <Eyebrow>04 — Contact</Eyebrow>
        <h2 className="font-display text-5xl font-medium leading-[1] tracking-tight text-white sm:text-7xl">
          Let's build <span className="italic font-light text-gradient">yours.</span>
        </h2>
        <p className="mt-6 max-w-lg text-base text-slate-300">
          Email or call me directly about a new website or monthly maintenance.
        </p>
      </Reveal>
      <div className="mt-12">
        <Row i={0} href={`mailto:${EMAIL}`} icon={Mail} label="Email" value={EMAIL} testId="email-link" />
        <Row i={1} href={`tel:${PHONE.replace(/-/g, "")}`} icon={Phone} label="Phone" value={PHONE} testId="phone-link" />
      </div>
    </div>
  </section>
);
